import React, { Component } from "react";
import { connect } from "react-redux";
import InputComponent from "../../components/form/InputComponent";
import SelectComponent from "../../components/form/SelectComponent";
import { css } from "aphrodite";
import SearchIcon from "@material-ui/icons/Search";
import { branchList } from "../../actions/master-data/branch_action";
import {
  getBranchListPending,
  getBranchList,
  getBranchListError,
} from "../../reducers/master-data/branch_reducer";
import { getUser } from "../../helpers/user";
import Button from "@material-ui/core/Button";
import { default_api } from "../../constants/default_api";
import _ from "lodash";
import { listHeaderStyles as styles } from "../../components/header/listHeaderStyles";

const SEARCH_DEBOUNCE_MS = 500;
class HeaderMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nama: "",
      branch: "",
      status: "",
    };
    this.handleChangeNama = this.handleChangeNama.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleChangeBranch = this.handleChangeBranch.bind(this);
  }

  handleChangeNama(e) {
    if (!e) {
      return;
    }

    const searchValue = e.target.value;
    this.setState({ nama: searchValue });

    clearTimeout(this.namaSearchTimeout);
    this.namaSearchTimeout = setTimeout(() => {
      this.props.handleRefresh({ search: searchValue });
    }, SEARCH_DEBOUNCE_MS);
  }

  handleChangeBranch(e) {
    if (e !== null) {
      this.props.handleRefresh({ branch_id: e.value });
    } else {
      this.props.handleRefresh({ branch_id: null });
    }
  }

  handleChangeStatus(e) {
    if (e !== null) {
      this.props.handleRefresh({ status: e.value });
    } else {
      this.props.handleRefresh({ status: null });
    }
  }

  handleDownload() {
    window.open(default_api + "/member/download/member_data.xlsx");
  }

  componentDidMount() {
    this.props.branchList({
      page: 1,
      length: 10,
      search_text: "",
      id: "",
    });
  }

  render() {
    const { branchList_data } = this.props;
    const role_code = getUser().role_codes[0];
    const showBranch =
      role_code !== "admin_paboi_cabang" &&
      role_code !== "ketua_paboi_cabang";
    let branchOption = [];
    const statusOption = [
      { value: 0, label: "Tidak Aktif" },
      { value: 1, label: "Aktif" },
      { value: 2, label: "Pensiun" },
      { value: 3, label: "Wafat" },
    ];
    if (branchList_data) {
      branchOption = branchList_data.map((value) => ({
        value: value.id,
        label: value.name,
      }));
    }

    return (
      <div className={css(styles.bar)}>
        <div className={css(styles.actions)} style={{ flex: "1 1 100%" }}>
          {role_code === "root" && (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={css(styles.buttonFull)}
              onClick={this.handleDownload}
            >
              Export Member PABOI
            </Button>
          )}
          <div className={css(styles.field)}>
            <InputComponent
              onChange={this.handleChangeNama}
              value={this.state.nama}
              placeholder="Cari Nama, ID PABOI"
              startIcon={SearchIcon}
              id="nama"
            />
          </div>
          {showBranch && (
            <div className={css(styles.field)}>
              <SelectComponent
                onChange={this.handleChangeBranch}
                placeholder="Cabang"
                options={branchOption}
                id="cabang"
                isAsync
                asyncUrl="master_data/branch/find"
              />
            </div>
          )}
          <div className={css(styles.field)}>
            <SelectComponent
              onChange={this.handleChangeStatus}
              placeholder="Status"
              options={statusOption}
              id="status"
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ branchList }) {
  return {
    branchList_pending: getBranchListPending(branchList),
    branchList_data: getBranchList(branchList),
    branchList_error: getBranchListError(branchList),
  };
}

export default connect(mapStateToProps, { branchList })(HeaderMember);
